import api from 'store/actions/api';
import { getTrackingId } from 'components/user/selectors';

export const toggleAdFavorite = (adId, isFavorite = true) =>
  function* ({ getState }) {
    const trackingId = getTrackingId(getState());

    if (trackingId) {
      if (isFavorite) {
        return yield api.addAdToFavorites(trackingId, adId);
      }

      return yield api.removeAdFromFavorites(trackingId, adId);
    }
  };
